import React from 'react'
import { StyledNotificationBanner } from './styles'
import Icon from '@/atoms/Icon'

const NotificationBanner = ({
  variant = 'info',
  children,
  iconSize,
  ariaLabel,
  style,
}) => {
  function getIcon() {
    switch (variant) {
      case 'success':
        return 'check'

      case 'warning':
      case 'error':
      case 'error_inverted':
        return 'alert-triangle'

      case 'info':
      default:
        return 'exclamation'
    }
  }

  return (
    <StyledNotificationBanner
      {...{ variant, iconSize }}
      {...style ? { style } : {}}
      {...ariaLabel ? { 'aria-label': ariaLabel } : {}}
    >
      <Icon
        name={getIcon()}
        {...ariaLabel ? { 'aria-hidden': true } : {}}
      />

      <span className={'notification-banner__label'}>
        {children}
      </span>

    </StyledNotificationBanner>
  )
}

export default NotificationBanner
